export enum Permission {
  PERMISSION_ACCESS_CMS = "PERMISSION_ACCESS_CMS",
  PERMISSION_COMMUNITY_ENGAGEMENT = "PERMISSION_COMMUNITY_ENGAGEMENT",
  PERMISSION_DEVELOPER_CONSOLE = "PERMISSION_DEVELOPER_CONSOLE"
}
